
import { css } from 'lit';
export default css`
.layout-two-col-border{
  border-top:2px solid var(--purple-medium-neutral);
}
:host(:is([background-color]:not([background-color='primary-white']))) .layout-two-col-border{
    background-color:var(--bg-color);
    border-top:none;
  }
:host([enclosed]) .layout-two-col-border{
    border-bottom:2px solid var(--purple-medium-neutral);
  }
@media (min-width: 992px){
.grid{
    display:flex;
    gap:var(--spacing-12)
}
  }
:host([degap]) .grid{
    gap:0px;
  }
.column-left,
.column-right{
  padding:2rem 0;
}
@media (min-width: 992px){
.column-left,
.column-right{
    width:50%;
    padding:3rem 0
}
  }
.clickable-card{
  gap:0px;
}
.clickable-card .column-left,
  .clickable-card .column-right{
    margin-left:calc(var(--spacing-8) * -1);
    margin-right:calc(var(--spacing-8) * -1);
    padding:2rem;
    position:relative;
  }
@media (min-width: 992px){
.clickable-card .column-left,
  .clickable-card .column-right{
      margin-left:auto;
      margin-right:auto;
      padding:3.5rem 3rem
  }
    }
.clickable-card .column-left:hover, .clickable-card .column-right:hover{
      background-color:var(--neutral-light);
    }
.divider{
  border-top:2px solid var(--purple-medium-neutral);
  margin-left:-2rem;
  margin-right:-2rem;
}
@media (min-width: 992px){
  .divider{
    border-top:0;
    border-left:2px solid var(--purple-medium-neutral);
    margin:0;
  }
}
`;